<template>
  <div
    v-if="sections"
    id="checkoutVue"
    class="checkout-vue-form"
  >
    <section
      :is="section.component"
      v-for="(section, i) in sections"
      :key="section.key"
      :currentsection="currentSection"
      :number="i - number"
      :hotel="hotel"
      :paymentfields="paymentFields"
      @section-update="updateSelectedSection"
      @payment-fields-update="updatePaymentHash"
      @refresh-add-ons="updateNumber"
      @hotels-in-cart="updateHotelSection"
    />
  </div>
</template>

<script>
import AddOns from './add_ons'
import Address from './address'
import HotelDetails from './hotel_details'
import Cart from './sidebar_cart'
import Payment from './payment'
import Review from './review'

export default {
  components: {
    Address,
    AddOns,
    Cart,
    HotelDetails,
    Payment,
    Review
  },

  data() {
    return {
      currentSection: 'none',
      number: 1,
      paymentFields: {},
      sections: [
        { key: 'Cart', component: Cart },
        { key: 'AddOns', component: AddOns },
        { key: 'Address', component: Address },
        { key: 'Hotel', component: HotelDetails },
        { key: 'Review', component: Review },
        { key: 'Payment', component: Payment }],
      topDiv: null,
      hotel: true
    }
  },

  mounted() {
    // Delay Div load so it doesn't scroll to view on page load
    setTimeout(function() { this.topDiv = document.querySelector('.checkout-container') }, 3000)
  },

  methods: {
    updateNumber(numOfAddOns) {
      if (numOfAddOns > 0) {
        this.number = 0
      } else {
        this.number = 1
      }

      // Notify Jquery Carousel AddOnItems have changed
      this.$emit('add-on-changed', numOfAddOns)
    },

    updateHotelSection(hotel) {
      if (!hotel) {
        this.hotel = false
        this.sections.splice(3, 1)
      }
    },

    updatePaymentHash(newFields) {
      this.paymentFields = Object.assign( {}, this.paymentFields, newFields )
    },

    updateSelectedSection(newSelectedSection) {
      if (this.currentSection == newSelectedSection) {
        this.currentSection = 'none'
      } else {
        if (this.topDiv) { this.topDiv.scrollIntoView({ behavior: 'smooth', block: 'start' }) }
        this.currentSection = newSelectedSection
      }
    }
  }
}
</script>
